module.exports = __webpack_public_path__ + "img/inclusao.abef1c6d.png";